import ct from './ct.json';
import en from './en.json';
import es from './es.json';

export { ct, en, es };
